











































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { Setting, Report, Dashboard } from '@/const/terms/sidebar/sidebar';
import scss from '@/assets/style/variables.scss';
import { MenuItem } from 'element-ui';

import { AxiosError, AxiosResponse } from 'axios';
import { State } from 'vuex-class';
import { UserState } from '../../../store/user/types';

@Component<Sidebar>({
    name: 'Sidebar',
})
export default class Sidebar extends Vue {
    @Prop({type: Boolean, default: false}) private alertIsOn!: boolean;
    private isCollapse: boolean = true;
    private menuTitle = {Setting, Report, Dashboard};
    private scss = scss;
    
    @State('User') private user!: UserState;

    get routerPath() {
        if (this.$route.meta.subRoot !== '') {
            return this.$route.meta.subRoot;
        }
        return this.$route.path;
    }
    get isUserOnestore(): boolean {
        return (this.user.customerInfo && this.user.customerInfo.company_no) === 375;
    }

    private preventAll (e: Event) {
        e.stopPropagation();
    }
}
